import React, { useEffect, useState } from "react";
import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
} from "@material-ui/core";
//theme
import Theme, { useStyles } from "../../../Theme.js";
// Images
import sentierBackground from "../../../../images/sentierBackground.jpg";
import GUIDES_DE_RANDONNEE from "../../../../images/pictos-ok/LES GUIDES-DE RANDONNÉE.svg";
import LOCATION from "../../../../images/pictos-ok/LOCATION.svg";
import PORTAGE_BAGAGE from "../../../../images/pictos-ok/LE PORTAGE DE BAGAGE.svg";
const Step1 = (props) => {
  const classes = useStyles();

  const [value, setValue] = useState("");

  useEffect(() => {
    if (props.result.sujet) {
      setValue(props.result.sujet);
      props.setAuthorization(true);
    } else {
      // Quand le composant se charge, bloque la possibilité de passer sans répondre
      props.setAuthorization(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event) => {
    // Set la value du state du composant local pour rendu graphique
    setValue(event.target.value);
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult["sujet"] = event.target.value;
    props.setResult(newResult);
    // Une fois que la réponse est donnée, autorise à avancer dans le form
    props.setAuthorization(true);
    props.goForth(true);
  };

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">
        Quel est le sujet de votre observation ?
      </FormLabel>
      <RadioGroup
        aria-label="sujet"
        name="sujet"
        value={value}
        onChange={handleChange}
      >
        <FormControlLabel
          value="guides"
          className={
            classes.themeButton + " " + (value === "guides" ? "checked" : "")
          }
          control={
            <Radio
              className={classes.fullradio}
              icon={
                <img
                  src={GUIDES_DE_RANDONNEE}
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  alt="Les guides de randonnées"
                />
              }
              checkedIcon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={GUIDES_DE_RANDONNEE}
                  alt="Les guides de randonnées"
                />
              }
            />
          }
          label="Les guides de randonnées"
        />
        <FormControlLabel
          value="materiel"
          className={
            classes.themeButton + " " + (value === "materiel" ? "checked" : "")
          }
          control={
            <Radio
              className={classes.fullradio}
              icon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={LOCATION}
                  alt="La location du matériel"
                />
              }
              checkedIcon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={LOCATION}
                  alt="La location du matériel"
                />
              }
            />
          }
          label="La location du matériel"
        />
        <FormControlLabel
          value="bagages"
          className={
            classes.themeButton + " " + (value === "bagages" ? "checked" : "")
          }
          control={
            <Radio
              className={classes.fullradio}
              icon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={PORTAGE_BAGAGE}
                  alt="Le portage des bagage"
                />
              }
              checkedIcon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={PORTAGE_BAGAGE}
                  alt="Le portage des bagage"
                />
              }
            />
          }
          label="Le portage des bagages"
        />
      </RadioGroup>
    </FormControl>
  );
};

export default Step1;
